module.exports = __webpack_public_path__ + "img/Enzymotherapy12.9e810d22.jpg";